module.exports = __webpack_public_path__ + "static/media/Right.a849e986.svg";